export class AbstractExtension {
    private _type: string | null;
    private _xmlElement: Element | null;
    constructor() {
        this._type = null;
        this._xmlElement = null;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get xmlElement() {
        return this._xmlElement;
    }

    set xmlElement(value) {
        this._xmlElement = value;
    }
}
